<div role="alert"
     class="alert alert-info">
    Copy a meeting or meeting template between organisations.
    This copies the agenda and all agenda items, but does not copy any of the meeting minutes or actions.
</div>

<form role="form">
    <div class="row">
        <div class="col-12 col-lg-8">
            <h1>Source</h1>
            <div class="form-group">
                <h4>Source Organisation</h4>
                <adapt-select-organisation (organisationChange)="onSourceOrganisationChanged($event)"></adapt-select-organisation>
            </div>

            @if (sourceOrganisation) {
                <div class="form-group">
                    <h4>Source Team (optional)</h4>
                    <adapt-select-team [organisation]="sourceOrganisation"
                                       [showClearButton]="true"
                                       (teamChange)="sourceTeam = $event"></adapt-select-team>
                </div>

                <div class="form-group">
                    <h4>Meeting or Template</h4>
                    <adapt-select-meeting-or-template [organisation]="sourceOrganisation"
                                                      [team]="sourceTeam"
                                                      (meetingOrTemplateChange)="updateMeetingOrTemplate($event)"></adapt-select-meeting-or-template>
                </div>
            }

            @if (sourceMeetingOrTemplate) {

                <hr />
                <h1>Destination</h1>

                <div class="form-group">
                    <h4>Destination Organisation</h4>
                    <adapt-select-organisation (organisationChange)="destinationOrganisation = $event"
                                               [filter]="filterSourceOrganisation"></adapt-select-organisation>
                </div>

                @if (destinationOrganisation) {
                    <div class="form-group">
                        <h4>Destination Team</h4>
                        <small class="text-muted">(Leave blank if the agenda is going to an Organisation)</small>
                        <adapt-select-team [organisation]="destinationOrganisation"
                                           [showClearButton]="true"
                                           [filter]="filterDestinationTeam"
                                           (teamChange)="destinationTeam = $event"></adapt-select-team>
                    </div>

                    <div class="form-group">
                        <h4>Copy as meeting</h4>
                        <dx-check-box [(value)]="copyAsMeeting"></dx-check-box>
                        @if (copyAsMeeting && !destinationTeam) {
                            <div class="alert alert-danger">Meetings can only be copied to a team, so set the destination team above.</div>
                        }
                    </div>
                }
            }

            @if (isComplete) {
                <div class="form-group">
                    <adapt-check-my-maths (isMyMathsOk)="isMyMathsOk=$event">
                    </adapt-check-my-maths>
                </div>
            }

            <button [adaptBlockingClick]="promiseToCopyMeetingOrTemplate"
                    [disabled]="!isMyMathsOk || !isComplete"
                    adaptButton="copy">meeting template</button>

            @if (error) {
                <div role="alert"
                     class="alert alert-danger">{{ error }}</div>
            }
        </div>
    </div>
</form>
